module.exports = "/_next/static/images/generic-3f32bafe342aa95c6fc93f32e1e33bf4.svg";